export class SwitchingStateInTimePeriod {
  cableGridElementID: number;
  fromNode_dsoInternalID: string;
  toNode_dsoInternalID: string;
  switchingState: string;
  planning: string;
  original: string

  constructor(cableGridElementID: number, fromNode_dsoInternalID: string, toNode_dsoInternalID: string, switchingState: string,  planning: string, original: string) {
    this.cableGridElementID = cableGridElementID;
    this.fromNode_dsoInternalID = fromNode_dsoInternalID;
    this.toNode_dsoInternalID = toNode_dsoInternalID;
    this.switchingState = switchingState;
    this.planning = planning;
    this.original = original;
  }
}

export class PlanningState {
  id: number;
  state: string;
  state_en: string;
  constructor(id: number, state: string, state_en: string) {
    this.id = id;
    this.state = state;
    this.state_en = state_en;
  }
}

export class PlanningSwitchingState {
  cableGridelementId: number;
  switchingState: string;
  fromNode_dsoInternalID: string;
  toNode_dsoInternalID: string;
  constructor(cableGridelementId: number, switchingState: string, fromNode_dsoInternalID: string, toNode_dsoInternalID: string) {
    this.cableGridelementId = cableGridelementId;
    this.switchingState = switchingState;
    this.fromNode_dsoInternalID = fromNode_dsoInternalID;
    this.toNode_dsoInternalID = toNode_dsoInternalID;
    }
    
}

